import { render, staticRenderFns } from "./SmsManage.vue?vue&type=template&id=8852da7a&scoped=true"
import script from "./SmsManage.vue?vue&type=script&lang=js"
export * from "./SmsManage.vue?vue&type=script&lang=js"
import style0 from "./SmsManage.vue?vue&type=style&index=0&id=8852da7a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8852da7a",
  null
  
)

export default component.exports